import { Grid, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const FormTermsWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap !important;
  .segment {
    margin: 0px !important;
    padding: 0px !important;
  }
`;

export const FormTermsAndPrivacy = styled.a`
cursor: pointer;
display: block;
white-space: nowrap;
text-overflow: ellipsis;
overflow: hidden;
&:hover {
  opacity: 0.7;
}

.ui.loading.segment::before {
background: none !important;
font-size: 5px !important;
}
`;

export const StyledGrid = styled(Grid)`
 padding: 15px !important;
 .column-value {
  font-weight: bold !important;
 }
`
export const SchedulerRow = styled(Grid.Row)`
align-items: end !important;
`
export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
border-radius: 1.3rem !important;
box-shadow: none !important;
padding: 15px;
padding-bottom: 15px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .header {
  margin-top: -1em !important;
  padding: 2rem 0rem 0rem 1rem !important;
  font-size: 18px !important;
 }
 .row {
  flew-wrap: no-wrap !important;
 }
`